/**
 * Newsletter sign-up flow
 *
 * @package EBNewsletters
 */

import { getEmail, saveEmail } from './store';
import {
	initModal,
	open,
	preloadIcons,
	renderRecommendations,
	setState,
} from './modal';

const SELECTOR = {
	data: '#ebn-data',
	card: '.card',
	signup: '[data-signup]',
};

const subscribe = (root, id, email) =>
	fetch(`${root}subscribe`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ id, email }),
	})
		.then(response => response.json())
		.catch(() => ({ status: 'error' }));

const initNewsletters = () => {
	const script = document.querySelector(SELECTOR.data);
	if (!script) {
		return;
	}

	const data = JSON.parse(script.textContent);
	preloadIcons(data);
	const root = script.dataset.rest;
	const cards = [...document.querySelectorAll(SELECTOR.card)];
	let current = null;
	let signupEmail = '';

	const finish = entry => {
		renderRecommendations(entry.recommendations, (recommendation, row) => {
			subscribe(root, recommendation.id, signupEmail).then(result => {
				if ('subscribed' === result.status) {
					row.classList.add('is-signed-up');
				}
			});
		});
		setState('success');
	};

	initModal(email => {
		if (!current) {
			return;
		}

		setState('loading');
		signupEmail = email;
		saveEmail(email);

		subscribe(root, current.id, email).then(result => {
			if ('subscribed' === result.status) {
				finish(current);
			} else {
				setState('error');
			}
		});
	});

	cards.forEach(card => {
		card.querySelector(SELECTOR.signup)?.addEventListener('click', () => {
			current = data[card.dataset.newsletter];
			open(current, getEmail());
		});
	});
};

export default initNewsletters;
